/* VENTI Complete the Look - Shopify Online Store Ajax API, no metafields or dependencies.
 * API: GET products/{handle}.js and POST cart/add.js (locale-aware).
 * Requires an approved asset venti-matches.js mapping actual Shopify handles.
 * Color matching fails closed if the selected item's color cannot be verified.
 */
(function () {
  'use strict';
  if (window.__ventiMatchingLoaded) return;
  window.__ventiMatchingLoaded = true;
  var matchData = window.VENTI_MATCHING_DATA;
  if (!matchData || matchData.schema !== 1 || matchData.state !== 'production' || !matchData.matches) return;
  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (!rootPath.endsWith('/')) rootPath += '/';
  var productCache = new Map();
  var currencyPromise = null;

  function normColor(value) {
    var s = String(value || '').toLowerCase().trim()
      .replace(/grey/g, 'gray').replace(/off[\s-]?white/g, 'offwhite')
      .replace(/[\u064b-\u065f]/g, '').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
    if (!s) return '';
    // The same multi-color palette can be listed in different order.
    return s.split(/\s+/).filter(Boolean).sort().join(' ');
  }
  function getOptionIndex(product, names) {
    var options = product && product.options || [];
    return options.findIndex(function (option) {
      var name = typeof option === 'string' ? option : (option && option.name) || '';
      return names.test(String(name).toLowerCase());
    });
  }
  function getVariantOption(variant, index) {
    if (!variant || index < 0) return '';
    return String((Array.isArray(variant.options) ? variant.options[index] :
      variant['option' + (index + 1)]) || '');
  }
  function eligibleVariants(sourceProduct, sourceVariant, targetProduct, link) {
    var sourceIndex = getOptionIndex(sourceProduct, /color|colour|لون|اللون/);
    var targetIndex = getOptionIndex(targetProduct, /color|colour|لون|اللون/);
    var sourceColor = normColor(getVariantOption(sourceVariant, sourceIndex) || link.source_color_hint);
    var list = (targetProduct.variants || []).filter(function (variant) {
      if (!variant.available || variant.requires_selling_plan) return false;
      var targetColor = normColor(getVariantOption(variant, targetIndex) || link.target_color_hint);
      // Both colors must be known, including when each product uses its own handle per color.
      return sourceColor && targetColor && sourceColor === targetColor;
    });
    return list;
  }
  function fetchProduct(handle) {
    if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle)) return Promise.reject(new Error('Invalid product handle'));
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch(rootPath + 'products/' + encodeURIComponent(handle) + '.js',
        {credentials:'same-origin'}).then(function (response) {
          if (!response.ok) throw new Error('Product not published or unavailable');
          return response.json();
        }));
    }
    return productCache.get(handle);
  }
  function currencyCode() {
    if (!currencyPromise) {
      var shopCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      currencyPromise = shopCurrency ? Promise.resolve(shopCurrency) :
        fetch(rootPath + 'cart.js', {credentials:'same-origin'}).then(function (r) {return r.json();})
          .then(function (cart) {return cart.currency || 'EGP';}).catch(function(){return 'EGP';});
    }
    return currencyPromise;
  }
  function money(cents, currency) {
    var amount = Number(cents) / 100;
    if (!Number.isFinite(amount)) return '';
    try {return new Intl.NumberFormat(document.documentElement.lang || 'en',
      {style:'currency',currency:currency || 'EGP'}).format(amount);}
    catch (_) {return amount.toFixed(2) + ' ' + (currency || 'EGP');}
  }
  function safeImage(source) {
    var url = typeof source === 'string' ? source : source && (source.src || source.url);
    if (!url || typeof url !== 'string') return '';
    if (url.startsWith('//')) return window.location.protocol + url;
    return /^https:\/\//i.test(url) ? url : '';
  }
  function node(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  }
  function chosenVariantId(section) {
    // Theme form is the normal authoritative source; the URL covers themes that keep ?variant updated.
    var forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
    var form = forms.find(function (f) {
      return f.querySelector('[name="id"]') && !f.closest('.venti-match');
    });
    var control = form && form.querySelector('[name="id"]');
    if (control && control.value && /^\d+$/.test(control.value)) return control.value;
    var viaUrl = new URLSearchParams(window.location.search).get('variant');
    if (viaUrl && /^\d+$/.test(viaUrl)) return viaUrl;
    return section.dataset.initialVariant || '';
  }
  function variantId(product, section) {
    var id = chosenVariantId(section);
    var variant = (product.variants || []).find(function (v) {return String(v.id) === String(id);});
    return variant || ((product.variants || []).length === 1 ? product.variants[0] : null);
  }
  function notice(element, message, showCart) {
    element.replaceChildren(document.createTextNode(message));
    if (showCart) {
      element.appendChild(document.createTextNode(' '));
      var anchor=node('a',null,'View bag');
      anchor.href=rootPath + 'cart';
      element.appendChild(anchor);
    }
    element.hidden=false;
  }
  async function refreshThemeCart() {
    var response = await fetch(rootPath+'cart.js', {credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error('Cart refresh unavailable');
    var cart = await response.json();
    var shared = window.sharedFunctions;
    if (!shared || typeof shared.updateSidebarCart !== 'function' || !document.getElementById('halo-cart-sidebar')) {
      throw new Error('Theme cart unavailable');
    }
    // Use Ella's own renderer and completion event for counts, drawer and shipping totals.
    await new Promise(function(resolve,reject){
      var timer;
      function cleanup(){clearTimeout(timer);document.removeEventListener('cart-update',complete);}
      function complete(){
        var wrapper=document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
        if (!wrapper || wrapper.classList.contains('is-loading')) return;
        cleanup();resolve();
      }
      document.addEventListener('cart-update',complete);
      timer=setTimeout(function(){cleanup();reject(new Error('Cart refresh timed out'));},10000);
      try {
        document.body.classList.add('cart-sidebar-show');
        shared.updateSidebarCart(cart);
      } catch(error){cleanup();reject(error);}
    });
  }
  function renderCard(targetProduct, variants, link, currency) {
    var card=node('article','venti-match__card');
    // Shopify variant images are preferred so the photo matches the selected color.
    var imageURL=safeImage(variants[0].featured_image) || safeImage(targetProduct.featured_image);
    var image=null;
    if (imageURL) {
      image=node('img','venti-match__photo');image.src=imageURL;
      image.alt=targetProduct.title || 'Matching garment';image.loading='lazy';
      card.appendChild(image);
    } else card.appendChild(node('div','venti-match__placeholder'));
    var details=node('div','venti-match__details');card.appendChild(details);
    var linkProduct=node('a','venti-match__product',targetProduct.title || 'Matching piece');
    linkProduct.href=rootPath+'products/'+encodeURIComponent(link.handle);
    details.appendChild(linkProduct);
    var price=node('p','venti-match__price','');details.appendChild(price);
    var colorIndex=getOptionIndex(targetProduct,/color|colour|لون|اللون/);
    if (colorIndex>=0) {
      var colorLabel=node('p','venti-match__color','Color: '+getVariantOption(variants[0],colorIndex));
      details.appendChild(colorLabel);
    }
    var sizeIndex=getOptionIndex(targetProduct,/size|مقاس|المقاس/);
    var label=node('label','venti-match__size-label',sizeIndex>=0 ? 'Choose size' : 'Choose option');
    var select=node('select','venti-match__size');
    var uniqueId='venti-size-'+Math.random().toString(36).slice(2);
    select.id=uniqueId;select.setAttribute('aria-label','Choose matching product size or variant');
    label.htmlFor=uniqueId;details.appendChild(label);
    var placeholder=node('option',null,'Select');placeholder.value='';select.appendChild(placeholder);
    variants.forEach(function (v) {
      var desc=sizeIndex>=0 ? getVariantOption(v,sizeIndex) : (v.public_title || v.title || 'One size');
      var opt=node('option',null,desc);opt.value=String(v.id);select.appendChild(opt);
    });
    details.appendChild(select);
    var button=node('button','venti-match__button','Add matching piece');
    button.type='button';button.disabled=true;details.appendChild(button);
    var status=node('p','venti-match__notice');status.hidden=true;status.setAttribute('aria-live','polite');
    details.appendChild(status);
    function updateSelection(){
      var choice=variants.find(function(v){return String(v.id)===select.value;});
      var current=choice || variants[0];
      price.textContent=money(current.price,currency);
      if (image) {
        var chosenImage=safeImage(current.featured_image) || safeImage(targetProduct.featured_image);
        if (chosenImage) image.src=chosenImage;
      }
      button.disabled=!choice;
      linkProduct.href=rootPath+'products/'+encodeURIComponent(link.handle) + (choice ? '?variant='+encodeURIComponent(choice.id) : '');
      status.hidden=true;
    }
    var adding=false;
    select.addEventListener('change',updateSelection);
    button.addEventListener('click',async function(){
      var choice=variants.find(function(v){return String(v.id)===select.value;});
      if (!choice || adding) return;
      adding=true;select.disabled=true;
      button.disabled=true;button.textContent='Adding…';
      try {
        var response=await fetch(rootPath+'cart/add.js',{
          method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:choice.id,quantity:1}]})
        });
        if (!response.ok) {
          var body=await response.json().catch(function(){return {};});
          throw new Error(body.description || body.message || 'Please try again.');
        }
        notice(status,'Added to your bag.',true);
        try {
          await refreshThemeCart();
        } catch (_) {
          // The add succeeded: never repeat it because only the display refresh failed.
          notice(status,'Added to your bag. Opening your bag…',true);
          window.location.assign(rootPath+'cart');
        }
      } catch (error) {
        notice(status,error.message || 'Could not add product. Please try again.',false);
      } finally {
        adding=false;select.disabled=false;
        button.textContent='Add matching piece';button.disabled=!select.value;
      }
    });
    updateSelection();
    return card;
  }
  async function initSection(section) {
    var handle=section.dataset.currentHandle;
    var links=matchData.matches[handle];
    if (!Array.isArray(links) || links.length===0) return;
    var container=section.querySelector('[data-venti-items]');
    if (!container) return;
    var sourceProduct;
    try {sourceProduct=await fetchProduct(handle);}catch(_){return;}
    var previousVariant='';
    var seq=0;
    async function refresh() {
      var v=variantId(sourceProduct,section);
      var id=v ? String(v.id) : '';
      if (id===previousVariant) return;
      previousVariant=id;
      var call=++seq;
      section.hidden=true;
      container.replaceChildren();
      if (!v || !v.available) return;
      var currency=await currencyCode();
      var results=await Promise.all(links.map(async function(link){
        try {
          var target=await fetchProduct(link.handle);
          var variants=eligibleVariants(sourceProduct,v,target,link);
          return variants.length ? renderCard(target,variants,link,currency) : null;
        } catch (_) {return null;}
      }));
      if (call!==seq) return;
      var used=new Set();
      results.forEach(function(card,index){
        if (!card || used.has(links[index].handle)) return;
        used.add(links[index].handle);container.appendChild(card);
      });
      section.hidden=container.children.length===0;
    }
    document.addEventListener('change',function(){setTimeout(refresh,0);});
    document.addEventListener('variant:change',function(){setTimeout(refresh,0);});
    document.addEventListener('product:variant-change',function(){setTimeout(refresh,0);});
    // Theme-specific swatches sometimes update only hidden variant input or URL.
    // A light polling fallback keeps colors in sync without modifying theme internals.
    var timer=setInterval(function(){
      if (!document.documentElement.contains(section)) {clearInterval(timer);return;}
      refresh();
    },750);
    refresh();
  }
  function start(){
    document.querySelectorAll('[data-venti-match]').forEach(function(el){initSection(el);});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start);
  else start();
  // Test-only pure helpers; never sent to Shopify as external services.
  if (window.__VENTI_TEST__) window.__VENTI_MATCHING_TEST__={normColor:normColor,eligibleVariants:eligibleVariants,getOptionIndex:getOptionIndex};
})();
